import React from 'react';
import { BarChart } from 'lucide-react';

const DashboardSummary = ({ tasks, statusOptions, currentUser }) => {
  const displayTasks = currentUser?.role === 'admin' ? tasks : tasks.filter(t => (t.equipe || []).includes(currentUser?.initials));
  if (!displayTasks || displayTasks.length === 0) return null;
  const statusCounts = displayTasks.reduce((acc, t) => { acc[t.status] = (acc[t.status] || 0) + 1; return acc; }, {});
  const totalTasks = displayTasks.length;
  
  return (
    <div className="lg:col-span-2 bg-[#181b26] border border-slate-700 rounded-xl p-6 shadow-sm flex flex-col mt-8 mb-4 animate-in fade-in">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-semibold flex items-center gap-2"><BarChart className="text-blue-400" size={18} /> {currentUser?.role === 'admin' ? 'Visão Geral do Volume de Tarefas' : 'Minhas Tarefas (Visão Geral)'}</h3>
      </div>
      {totalTasks > 0 ? (
        <div className="flex-1 flex flex-col min-h-[200px]">
          <div className="flex-1 flex relative">
            <div className="flex flex-col justify-between pr-3 py-2 text-xs text-slate-500 text-right w-12">
              <span>{Math.max(...Object.values(statusCounts), 1)}</span>
              <span>{Math.round(Math.max(...Object.values(statusCounts), 1) * 0.75)}</span>
              <span>{Math.round(Math.max(...Object.values(statusCounts), 1) * 0.5)}</span>
              <span>{Math.round(Math.max(...Object.values(statusCounts), 1) * 0.25)}</span>
              <span>0</span>
            </div>
            <div className="flex-1 relative border-l border-b border-slate-700/50">
              <div className="absolute inset-0 flex flex-col justify-between pointer-events-none">
                {[100, 75, 50, 25, 0].map((pct) => (
                  <div key={pct} className="border-t border-slate-700/30 w-full" style={{ borderTopStyle: pct === 0 ? 'none' : 'solid' }}></div>
                ))}
              </div>
              <div className="absolute inset-0 flex items-end gap-1 sm:gap-2 px-2 pb-0">
                {Object.entries(statusCounts).sort((a,b) => b[1] - a[1]).map(([status, count]) => {
                   const maxVal = Math.max(...Object.values(statusCounts), 1);
                   const heightPct = `${(count / maxVal) * 100}%`;
                   const bgClass = statusOptions[status]?.split(' ')[0] || 'bg-slate-700';
                   return (
                     <div key={status} className="flex flex-col items-center justify-end flex-1 min-w-[50px] h-full group">
                       <div className={`w-full max-w-[60px] rounded-t-sm ${bgClass} transition-all duration-500 relative group-hover:brightness-110`} style={{ height: heightPct, minHeight: '4px' }}>
                         <span className="absolute -top-5 left-1/2 -translate-x-1/2 text-xs font-bold text-slate-300">{count}</span>
                       </div>
                     </div>
                   )
                })}
              </div>
            </div>
          </div>
          <div className="flex pl-12 pt-2">
            {Object.entries(statusCounts).sort((a,b) => b[1] - a[1]).map(([status]) => (
              <div key={status} className="flex-1 min-w-[50px] text-center">
                <span className="text-[10px] font-medium text-slate-400 truncate block px-1">{status === 'VAZIO' ? 'S/ STATUS' : status}</span>
              </div>
            ))}
          </div>
          <div className="absolute left-2 top-1/2 -translate-y-1/2 -rotate-90 text-xs text-slate-500 font-medium">Contagem</div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center flex-1 min-h-[160px] text-slate-500">
          <p>Nenhuma tarefa agendada para este período.</p>
        </div>
      )}
    </div>
  );
};

export default DashboardSummary;
